import { useEffect } from 'react';
import { logoutAction } from '../../store/actions/authActions';
import dynamicfunction from '../../utils/dynamicfunction';
import { useDispatch } from 'react-redux';
import { setAccountOpening, setApplicationId } from '../../store/slices/contentSlice';
import { setToken } from '../../utils/utils';

export default () => {
  const { TextWeight, isArabic } = dynamicfunction();
  const dispatch = useDispatch()

  // application is submitted: end the session now that the form is unmounted
  useEffect(() => {
    dispatch(setAccountOpening(null))
    dispatch(setApplicationId(null))
    setToken("")
    dispatch(logoutAction());
  }, []);


  const handleLogout = () => {
    window.location.href = `${process.env.REACT_APP_OPEN_ACCOUNT_LINK}${isArabic ? 'ar' : 'en'}`;
  };

  return {
    TextWeight,
    handleLogout,
    isArabic
  };
};
